<script setup lang="ts">
withDefaults(defineProps<{ minGridHeight?: string, bottomPadding?: boolean }>(), {
  minGridHeight: '200px',
  bottomPadding: false
})
</script>

<template>
  <div class="flex flex-col h-full">
    <div class="shrink-0">
      <slot />
    </div>
    <div
      class="flex-1 overflow-hidden"
      :class="{ 'pb-2': bottomPadding }"
      :style="{ minHeight: minGridHeight }"
    >
      <slot name="grid" />
    </div>
    <slot name="footer" />
  </div>
</template>
